(function () {
  'use strict';

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function safeBool(v) {
    return v === true || v === 'true' || v === '1';
  }

  function getProductRoot(el) {
    return el.closest('[data-section-id]') || el.closest('[class*="st_product-info--"]') || document;
  }

  function getVariants(root) {
    var script = root.querySelector('[data-st-variants]');
    if (!script) return [];
    try { return JSON.parse(script.textContent || '[]'); }
    catch (e) { return []; }
  }

  function initReviewStars(scope) {
    qsa('[data-stn-review-stars]:not([data-stn-ready])', scope).forEach(function (root) {
      root.setAttribute('data-stn-ready', '1');
      root.addEventListener('click', function () {
        var target = document.querySelector('.st_reviews_widget, [data-stn-review-slider]');
        if (!target) return;
        var y = target.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
      root.style.cursor = 'pointer';
    });
  }

  function setInventoryState(el, state, text) {
    el.classList.remove('stn-inventory--available', 'stn-inventory--sold_out', 'stn-inventory--limited', 'stn-inventory--soon_available');
    el.classList.add('stn-inventory--' + state);
    var textEl = el.querySelector('.stn-inventory__text');
    if (textEl && text != null) textEl.textContent = text;
  }

  function initInventory(scope) {
    qsa('[data-stn-inventory]:not([data-stn-ready])', scope).forEach(function (el) {
      el.setAttribute('data-stn-ready', '1');
      if (el.dataset.tracking !== 'dynamic') return;

      var root = getProductRoot(el);
      var variants = getVariants(root);
      var input = root.querySelector('[data-st-variant-id], form[action*="/cart/add"] input[name="id"]');

      function update() {
        if (!input) input = root.querySelector('[data-st-variant-id], form[action*="/cart/add"] input[name="id"]');
        if (!input) return;
        var id = String(input.value || '');
        var variant = variants.find(function (v) { return String(v.id) === id; });
        if (!variant) return;
        if (variant.available) {
          setInventoryState(el, 'available', el.dataset.availableText || 'In stock - delivered in 3 to 5 days');
        } else {
          setInventoryState(el, 'sold_out', el.dataset.soldOutText || 'Sold out');
        }
      }

      root.addEventListener('change', function () { setTimeout(update, 0); });
      document.addEventListener('variant:change', update);
      if (input && 'MutationObserver' in window) {
        new MutationObserver(update).observe(input, { attributes: true, attributeFilter: ['value'] });
      }
      update();
    });
  }

  function createSwiper(el, params) {
    if (!el || !window.Swiper) return null;
    try { return new window.Swiper(el, params); }
    catch (e) { return null; }
  }

  function initUGC(scope) {
    qsa('[data-stn-ugc]:not([data-stn-ready])', scope).forEach(function (root) {
      root.setAttribute('data-stn-ready', '1');
      var swiperEl = root.querySelector('.stn-ugc__swiper');
      var prev = root.querySelector('.stn-ugc__prev');
      var next = root.querySelector('.stn-ugc__next');
      var pagination = root.querySelector('.stn-ugc__pagination');
      var slideEls = qsa('[data-stn-ugc-slide]', root);
      var swiper = createSwiper(swiperEl, {
        slidesPerView: 3,
        spaceBetween: 10,
        watchOverflow: true,
        navigation: { prevEl: prev, nextEl: next },
        pagination: pagination ? { el: pagination, type: 'progressbar' } : undefined,
        breakpoints: {
          0: { slidesPerView: 2.25, spaceBetween: 8 },
          560: { slidesPerView: 3, spaceBetween: 10 }
        }
      });
      if (!swiper && swiperEl) swiperEl.style.opacity = '1';

      var modal = root.querySelector('.stn-ugc-modal');
      var modalMedia = root.querySelector('.stn-ugc-modal__media');
      var modalPrev = root.querySelector('.stn-ugc-modal__prev');
      var modalNext = root.querySelector('.stn-ugc-modal__next');
      var active = 0;

      function renderModal() {
        if (!modalMedia || !slideEls.length) return;
        active = (active + slideEls.length) % slideEls.length;
        var s = slideEls[active];
        var video = s.dataset.video || '';
        var poster = s.dataset.poster || '';
        modalMedia.innerHTML = '';
        if (video) {
          var v = document.createElement('video');
          v.src = video;
          v.controls = true;
          v.autoplay = true;
          v.playsInline = true;
          v.muted = false;
          if (poster) v.poster = poster;
          modalMedia.appendChild(v);
        } else if (poster) {
          var img = document.createElement('img');
          img.src = poster;
          img.alt = '';
          modalMedia.appendChild(img);
        }
      }

      function openModal(index) {
        if (!modal) return;
        active = index;
        renderModal();
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
      }

      function closeModal() {
        if (!modal) return;
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        if (modalMedia) modalMedia.innerHTML = '';
      }

      slideEls.forEach(function (slide, index) {
        var button = slide.querySelector('.stn-ugc__media');
        if (button) button.addEventListener('click', function () { openModal(index); });
      });
      qsa('[data-stn-ugc-close]', root).forEach(function (b) { b.addEventListener('click', closeModal); });
      if (modalPrev) modalPrev.addEventListener('click', function () { active -= 1; renderModal(); });
      if (modalNext) modalNext.addEventListener('click', function () { active += 1; renderModal(); });
      document.addEventListener('keydown', function (e) {
        if (!modal || !modal.classList.contains('is-open')) return;
        if (e.key === 'Escape') closeModal();
        if (e.key === 'ArrowLeft') { active -= 1; renderModal(); }
        if (e.key === 'ArrowRight') { active += 1; renderModal(); }
      });
    });
  }

  function initReviewSliders(scope) {
    qsa('[data-stn-review-slider]:not([data-stn-ready])', scope).forEach(function (root) {
      root.setAttribute('data-stn-ready', '1');
      var swiperEl = root.querySelector('.stn-review-slider__swiper');
      var prev = root.querySelector('.stn-review-slider__prev');
      var next = root.querySelector('.stn-review-slider__next');
      var count = qsa('.swiper-slide', swiperEl).length;
      var doLoop = safeBool(root.dataset.loop) && count > 1;
      var doAutoplay = safeBool(root.dataset.autoplay) && count > 1;
      var delay = Math.max(2, parseInt(root.dataset.delay || '5', 10)) * 1000;
      var swiper = createSwiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 12,
        loop: doLoop,
        watchOverflow: true,
        autoHeight: true,
        autoplay: doAutoplay ? { delay: delay, disableOnInteraction: false } : false,
        navigation: { prevEl: prev, nextEl: next }
      });
      if (!swiper && swiperEl) swiperEl.style.opacity = '1';
    });
  }

  function addDays(date, amount, includeWeekends) {
    var d = new Date(date.getTime());
    if (includeWeekends) {
      d.setDate(d.getDate() + amount);
      return d;
    }
    var added = 0;
    while (added < amount) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return d;
  }

  function formatDate(date) {
    try {
      return new Intl.DateTimeFormat(document.documentElement.lang || 'en', { month: 'long', day: 'numeric' }).format(date);
    } catch (e) {
      return date.toLocaleDateString(undefined, { month: 'long', day: 'numeric' });
    }
  }

  function initShipping(scope) {
    qsa('[data-stn-shipping]:not([data-stn-ready])', scope).forEach(function (root) {
      root.setAttribute('data-stn-ready', '1');
      var shippingDays = Math.max(1, parseInt(root.dataset.shippingDays || '3', 10));
      var deliveryDays = Math.max(1, parseInt(root.dataset.deliveryDays || '3', 10));
      var intervalHours = Math.max(1, parseInt(root.dataset.countdownHours || '3', 10));
      // Original widget's false setting behaves like calendar-day math in the supplied screenshot.
      var includeWeekends = root.dataset.countWeekends !== 'true';
      var hoursLabel = root.dataset.hoursLabel || 'Hrs.';
      var minutesLabel = root.dataset.minutesLabel || 'Min.';
      var countdownEl = root.querySelector('[data-stn-countdown]');
      var shippedEl = root.querySelector('[data-stn-shipped-date]');
      var deliveredEl = root.querySelector('[data-stn-delivered-date]');

      function updateDates() {
        var now = new Date();
        var shipStart = addDays(now, shippingDays, includeWeekends);
        var shipEnd = addDays(shipStart, shippingDays, includeWeekends);
        var deliveryStart = shipEnd;
        var deliveryEnd = addDays(deliveryStart, deliveryDays, includeWeekends);
        if (shippedEl) shippedEl.textContent = formatDate(shipStart) + ' - ' + formatDate(shipEnd);
        if (deliveredEl) deliveredEl.textContent = formatDate(deliveryStart) + ' - ' + formatDate(deliveryEnd);
      }

      function updateCountdown() {
        var now = new Date();
        var target = new Date(now.getTime());
        target.setMinutes(0, 0, 0);
        var nextHour = Math.floor(now.getHours() / intervalHours) * intervalHours + intervalHours;
        if (nextHour >= 24) {
          target.setDate(target.getDate() + 1);
          nextHour -= 24;
        }
        target.setHours(nextHour);
        var diff = Math.max(0, target.getTime() - now.getTime());
        var mins = Math.floor(diff / 60000);
        var h = Math.floor(mins / 60);
        var m = mins % 60;
        if (countdownEl) {
          countdownEl.textContent =
            String(h).padStart(2, '0') + ' ' + hoursLabel + ' ' +
            String(m).padStart(2, '0') + ' ' + minutesLabel;
        }
      }

      updateDates();
      updateCountdown();
      root._stnTimer = setInterval(updateCountdown, 30000);
    });
  }

  function init(scope) {
    initReviewStars(scope);
    initInventory(scope);
    initUGC(scope);
    initReviewSliders(scope);
    initShipping(scope);
  }

  function boot() { init(document); }

  if (!window.__STN_NATIVE_PRODUCT_BLOCKS__) {
    window.__STN_NATIVE_PRODUCT_BLOCKS__ = true;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
  } else {
    boot();
  }
})();
